export const BADGE_MODELS = [
  'new',
  'seasonal',
  'exclusive',
  'trending',
  'bestseller',
  'custom',
  'guaranteed',
  'top rated',
  'popular',
  'installed'
];

export const INSPIRATIONAL_BADGE_MODELS = [
  'new',
  'trending',
  'bestseller',
  'exclusive'
];

export const EXPERIENCE_TAGS = {
  GIFT_CARD: 'GIFT_CARD'
};

export const BADGE_MESSAGE = {
  GIFT_CARD: 'Gift Card with Purchase'
};

export const BADGE_BACKGROUND_COLORS = {
  GIFT_CARD: '#E0F8ED'
};

export const BADGE_TEXT_COLORS = {
  GIFT_CARD: 'black'
};

export const FEATURE_SWITCHES = {
  ENABLE_GIFT_CARD_PROMOTIONS: 'enableGiftCardPromotions'
};

export const MAX_BADGE_DISPLAY_COUNT_MOBILE = 4;
